import { render } from "./ListDataIzinTidakSetuju.vue?vue&type=template&id=0721a084"
import script from "./ListDataIzinTidakSetuju.vue?vue&type=script&lang=js"
export * from "./ListDataIzinTidakSetuju.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__